export const gtag = (
  category,
  action,
  label,
  js = "",
  custom_dimensions = {}
) => {
  const keys = ["new_Category", "new_Action", "new_Label", "journey_Source"];
  const values = [category, action, label, js];

  for (let i = 0; i < 4; i++) {
    custom_dimensions[keys[i]] = values[i];
  }

  custom_dimensions["event"] = "MSTeams";

  // console.log(custom_dimensions)
  //@ts-ignore
  window.dataLayer.push(custom_dimensions);
};
